function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.31 18.93C11.17 18.93 7.82 15.58 7.82 11.44C7.82 7.3 11.1 4.02 15.18 3.95C15.21 3.95 15.24 3.93 15.28 3.92C14.94 3.37 14.35 3 13.66 3H5.9C4.85 3 4 3.84 4 4.89V19.69C4 20.74 4.85 21.59 5.9 21.59H13.66C14.71 21.59 15.56 20.74 15.56 19.69V18.92C15.48 18.92 15.4 18.93 15.32 18.93H15.31ZM11.27 20.09H8.29C7.99 20.09 7.75 19.85 7.75 19.54C7.75 19.23 7.99 18.99 8.29 18.99H11.27C11.57 18.99 11.81 19.23 11.81 19.54C11.81 19.85 11.57 20.09 11.27 20.09Z",
  fill: "#00A94F"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.0602 8.50047C20.9802 8.46047 20.9002 8.45047 20.8102 8.45047C20.6602 8.45047 20.5102 8.51047 20.4002 8.61047C19.3702 6.71047 17.3702 5.48047 15.1602 5.48047C11.8802 5.48047 9.2002 8.15047 9.2002 11.4405C9.2002 14.7305 11.8702 17.4005 15.1602 17.4005C15.9002 17.4005 16.6302 17.2605 17.3202 16.9905C17.6302 16.8705 17.7802 16.5205 17.6602 16.2205C17.5702 15.9805 17.3402 15.8405 17.1002 15.8405C17.0302 15.8405 16.9502 15.8505 16.8802 15.8805C16.3302 16.1005 15.7502 16.2005 15.1502 16.2005C12.5302 16.2005 10.3902 14.0605 10.3902 11.4405C10.3902 8.82047 12.5302 6.68047 15.1502 6.68047C16.8702 6.68047 18.4302 7.61047 19.2702 9.05047C19.0402 9.05047 18.8202 9.19047 18.7302 9.42047C18.6002 9.72047 18.7402 10.0805 19.0502 10.2005L20.1002 10.6405C20.1802 10.6705 20.2502 10.6905 20.3302 10.6905C20.5602 10.6905 20.7802 10.5605 20.8702 10.3405L21.3402 9.30047C21.4802 9.00047 21.3402 8.64047 21.0402 8.51047L21.0602 8.50047Z",
  fill: "#00A94F"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.8496 13.8999V13.3199C12.5796 12.7499 13.0796 12.3599 13.4096 12.0499C13.9196 11.5699 14.0596 11.3099 14.0596 10.9599C14.0596 10.5599 13.7496 10.2699 13.3196 10.2699C12.9396 10.2699 12.6396 10.4599 12.3296 10.9199L11.8096 10.5199C12.1996 9.89988 12.6796 9.62988 13.3696 9.62988C14.2296 9.62988 14.7996 10.1499 14.7996 10.9499C14.7996 11.4999 14.5896 11.8899 13.8696 12.5299C13.7096 12.6699 13.5196 12.8399 13.2796 13.0099C13.0996 13.1399 13.1396 13.2799 13.3296 13.2799H14.8996V13.9299H11.8396L11.8496 13.8999Z",
  fill: "#00A94F"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M17.6198 13.9002V13.0702H15.5498V12.5402L17.5698 9.66016H18.3198V12.4602H18.9398V13.0602H18.6298C18.4298 13.0602 18.3298 13.1602 18.3298 13.3602V13.8902H17.6298L17.6198 13.9002ZM16.3398 12.4702H17.6198V10.9502C17.6198 10.8102 17.5098 10.7902 17.4298 10.9102L16.3398 12.4702Z",
  fill: "#00A94F"
});

function SvgKbankCallCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKbankCallCenter);
export default __webpack_public_path__ + "static/media/kbank_call_center.4231a43c.svg";
export { ForwardRef as ReactComponent };